export enum PicklistType {
  Service = "service",
  Language = "language",
  Application = "application",
  Testemonial = "testemonial",
}
export enum EntityPicklistType {
  Destinations = "destinations",
  Companies = "companies",
  Organizers = "organizers",
  Hotels = "hotels",
  Customers = "customers",
}
